import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput ,MDBDataTable  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption , MDBIcon, MDBFormInline} from "mdbreact";
import {  MDBRow, MDBCol } from "mdbreact";

import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip , Divider } from 'antd';
import { api } from '../../api';
import Swal from 'sweetalert2'

export default class Modaladdfileex extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,
  loading:false,





   name_workorder:'',

   code:'',
   id_workorder:'',
   name_worklist:'',
   num_worklist:'',
   price_worklist:'',
   description_worklist:'',
   material_worklist:'',
   materialvinyl_worklist:'',
   papertype_worklist:'',
   statecut_worklist:'',
   status_worklist:'1',

   worklistdata:[],
   URL_work:'',
   exampledesign_workorder:'',
   filedesing_workorder:'',
   urlfolder_workorder:'',
   urlsourcecode_workorder:'',





}

//this.handleChange = this.handleChange.bind(this);
//this.handleChange2 = this.handleChange2.bind(this);
//this.handleChange3 = this.handleChange3.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.toggle = this.toggle.bind(this);
//this.handleChange4 = this.handleChange4.bind(this);
this.handleChangefile = this.handleChangefile.bind(this);
this.onTextChange = this.onTextChange.bind(this);
this.onChangetype = this.onChangetype.bind(this);
this.onClick = this.onClick.bind(this);
this.onClickmaterialvinyl = this.onClickmaterialvinyl.bind(this);
this.onClickpapertype = this.onClickpapertype.bind(this);
this.onClickstatecut = this.onClickstatecut.bind(this);
this.getworklist = this.getworklist.bind(this);



}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.props.selectatf();
 this.setState({ id_workorder:this.props.id_workorder})
  
 this.getworklist();
}

handleChangefile(event) {    this.setState({exampledesign_workorder: event.target.files[0]});  }

onTextChange = (e) => {
  this.setState({ [e.target.name]: e.target.value })
}

onChangetype(value) {
  this.setState({ paymentstatus_workorder:value})
}

onClick = (nr) => () => {
  this.setState({
    material_worklist: nr,
  });
};

onClickmaterialvinyl = (nr) => () => {
  this.setState({
    materialvinyl_worklist: nr,
  });
};

onClickpapertype = (nr) => () => {
  this.setState({
    papertype_worklist: nr,
  });
};

onClickstatecut = (nr) => () => {
  this.setState({
    statecut_worklist: nr,
  });
};

getworklist (){
    const {id_workorder} = this.state.id_workorder
    api.get('selectworklistshow.php?id_workorder='+this.props.id_workorder)
    .then(res => {
    //  console.log(res);
      this.setState({ worklistdata: res.data, loading: false })
    //  this.setState({ NAME: res.data[0].NAME})
    //  this.setState({ PNAME: res.data[0].PNAME})
     // this.setState({ FACULTY: res.data[0].FACULTY})
    }) 
}





 componentDidMount() {
     // const { code } = this.props.code
   //   console.log(id_send);
     this.setState({ code:this.props.code})
     this.setState({ name_workorder:this.props.name_workorder})
     this.setState({ id_workorder:this.props.id_workorder})
     this.setState({ filedesing_workorder:this.props.filedesing_workorder})
    
     

  }

//   getExpert() {
//     setTimeout(() => {
//       //ภายใน
//        Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
//       .then(res => {
//         console.log(res);
//       //  this.setState({ bankname: res.data, loading: false })
//         this.setState({ Expert: res.data})
//       }) 

//     }, 0);

// }


 // handleChange(event) {    this.setState({filecomment1: event.target.files[0]});  }
 // handleChange3(event) {    this.setState({filecomment2: event.target.files[0]});  }
 // handleChange2(event) {    this.setState({send_comment1: event.target.value});  }
 // handleChange4(event) {    this.setState({send_comment4: event.target.value});  }


  handleSubmit(e) {
    e.preventDefault();
    // alert('A name was submitted: ' + this.state.value);
    const date = new Date().toISOString().slice(0, 10)
   setTimeout(() => {

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("urldesing_workorder", this.state.URL_work);
      datafrm.append("urlsourcecode_workorder", this.state.urlsourcecode_workorder);
      datafrm.append("urlfolder_workorder", this.state.urlfolder_workorder);
      datafrm.append("filedesing_workorder", this.state.exampledesign_workorder);
      datafrm.append("datesentmf_workorder", date);
      datafrm.append("statussentmf_workorder", 1);
      datafrm.append("id_workorder", this.state.id_workorder);
    
      api.post("updatedesing.php",datafrm,{
            headers: {
                'content-type': 'multipart/form-data'
            }
        })

   .then(res => {
    if (res.status=== 200) {
        Swal.fire({
            title: 'บันทึกรายการสำเร็จ',
            icon: 'success',
          // showCancelButton: true,
            confirmButtonText: 'ตกลง',
          // cancelButtonText: 'No, keep it'
          }).then((result) => {
            this.toggle();  
          this.getworklist();
            this.props.getwork();
          })
    }else{
      message.error("อัพโหลไฟล์ไม่สำเร็จ!")
    }

  })


//อัพเดทสถานะ
  // Axios
  // // .post("https://admission.kpru.ac.th/refund/api/getdata/getuseradmin", { Username: this.form.name, Password: this.form.pass })
  //   .post("https://conference.kpru.ac.th/PHPAPI/updatestapat4.php",datafrm)
  //   .then(res => {
  //     console.log("response: ", res)
 
  //     if (res.data.length !== 0) {
  //      // this.showitem = true;
  //       console.log(res)
  //       console.log(res.data.length)
  //    }else{
  //     // window.location.href = '/'
  //    }
  //    this.toggle()
  //  })
  // this.toggle()


}, 2000);

//window.location.href = '/adminfaculty'
//this.props.updateat();
//this.getExpert()
 
  }


    render() {

console.log(this.state.URL_work)
console.log(this.state.urlfolder_workorder)




//console.log("1".padStart(5, "0"));
        return (
            <>
            <MDBBtn onClick={this.toggle} color="mdb-color" size="sm"><MDBIcon far icon="plus-square" /> แนบไฟล์</MDBBtn>

            
            <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg" >
              <MDBModalHeader toggle={this.toggle} className="text-center"><MDBIcon icon="align-left" /> แนบไฟล์งานออกแบบ</MDBModalHeader><br/>
              {/* <div className="text-center"><h4>ร้านลูกแม่น้ำปิงไวนิล 055-023245, 092-5583982, 0827730380</h4></div> */}
              
            
              <MDBModalBody className="text-left">
              <div>
              <MDBAlert color="primary" >
                <h5 className="text-left"> รหัสใบสั่งงาน : {this.state.code}</h5>   <br/>
                <h5 className="text-left"> ชื่อใบสั่งงาน : {this.state.name_workorder}</h5> 
              </MDBAlert>
                  <br/>
                
              <form onSubmit={this.handleSubmit}>
                            <div className="mb-2">
                                <label className="font-weight-bold"><MDBIcon icon="bible" /> URL File ออกแบบ </label>
                                <input className="form-control" onChange={this.onTextChange} name="URL_work"
                                    value={this.state.URL_work} placeholder="" required />
                            </div>
                            <div className="mb-2">
                                <label className="font-weight-bold"><MDBIcon icon="bible" /> URL sourcecode </label>
                                <input className="form-control" onChange={this.onTextChange} name="urlsourcecode_workorder"
                                    value={this.state.urlsourcecode_workorder} placeholder="" required />
                            </div>
                            <div className="mb-2">
                                <label className="font-weight-bold"><MDBIcon icon="bible" /> URL folder </label>
                                <input className="form-control" onChange={this.onTextChange} name="urlfolder_workorder"
                                    value={this.state.urlfolder_workorder} placeholder="" required />
                            </div>
                            <br/>
                            <MDBRow>
                              <MDBCol md="12">
                              <div className="mb-2">
                                  <label className="font-weight-bold"><MDBIcon icon="paperclip" /> ไฟล์ตัวอย่างออกแบบ .jpg (ขนาดเล็ก) 480x200 px</label><br/>
                                  {/* <MDBInput   group   type="file" validate error="wrong"
                                    success="right"  name="file" value={this.state.value} onChange={this.handleChange}/> */}

                                  {/* <input className="custom-file-input" type="file" onChange={this.handleChangefile} name="auth_agency" 
                                      value={this.state.auth_agency} placeholder="" required /> */}
                                       {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                        success="right"  name="file" accept="image/x-png,image/jpg,image/jpeg" value={this.state.value} onChange={this.handleChange} required/> */}
                                        <input type="file" id="img" name="exampledesign_workorder" onChange={this.handleChangefile} accept="image/x-png,image/jpg,image/jpeg" ></input>
                                </div>
                                </MDBCol>
                             
                            </MDBRow>
                            {/* <Divider orientation="left" plain>
                            Left Text
                            </Divider> */}
                            {this.state.filedesing_workorder =='' && this.state.filedesing_workorder ==null ?<></>:<>
                             <MDBRow>
                                <MDBCol>
                                  <img src={`https://lookmaenamping.com/sorlalumbackend/uploadsdesing/${this.state.filedesing_workorder}`} className="rounded mx-auto d-block " width="500" alt="aligment" />
                                </MDBCol>
                              </MDBRow>
                            </>}
                             
                 

                            {/* <p className="purple-text text-center">ตรวจสอบข้อมูลว่าถูกต้องครบถ้วน</p> */}
                            <div className="mt-3 text-center" >
                                <MDBBtn type="submit" color="primary" className="text-center"> <MDBIcon far icon="save" /> บันทึก</MDBBtn>
                            </div>


                        </form>
              </div>

              {/* {persons} */}


              </MDBModalBody>
              <MDBModalFooter>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                {/* <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn> */}
              </MDBModalFooter>
            </MDBModal>
          </>
          
        )
    }
}
